/**
 * @copyright 2025 Cooltrax Pty Ltd. All rights reserved.
 */

import React from 'react'

import { Loader } from '@/components/ui'

/**
 * Centred spinner with a label, for waits long enough to need acknowledging.
 *
 * The admin pages hang on an Auth0 Management API round trip (~0.5s for a user, longer for
 * the list), which is long enough that a bare skeleton in an unsized container reads as a
 * frozen page. The min-height keeps the spinner from collapsing to nothing.
 */
export const LoadingPanel: React.FC<{ label: string }> = ({ label }) => (
  <div className="flex min-h-64 flex-col items-center justify-center gap-3" role="status" aria-live="polite">
    <div className="h-10 w-10">
      <Loader size="lg" />
    </div>
    <span className="text-sm text-base-content/70">{label}</span>
  </div>
)

export default LoadingPanel
